import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost';
  size?: 'sm' | 'md';
};

export function Button({
  className,
  variant = 'primary',
  size = 'md',
  ...rest
}: Props) {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center rounded-md font-medium transition disabled:cursor-not-allowed disabled:opacity-50',
        size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm',
        variant === 'primary' &&
          'bg-lex-magenta text-white hover:bg-lex-magenta/90',
        variant === 'secondary' &&
          'border border-lex-slate-200 bg-white text-lex-slate-900 hover:bg-lex-slate-50',
        variant === 'ghost' &&
          'text-lex-slate-700 hover:bg-lex-slate-100',
        className,
      )}
      {...rest}
    />
  );
}
